import Vue from 'vue'
import Router from 'vue-router'
import LandingPage from './views/LandingPage'

import LetterPage from './views/letter/LetterPage'
import UploadPage from './views/letter/upload/UploadPage'
import LetterOptionsPage from './views/letter/upload/LetterOptionsPage'
import UploadSelectionPage from './views/letter/upload/UploadSelectionPage'
import UploadLetterPage from './views/letter/upload/UploadLetterPage'
import PreviewLetterPage from './views/letter/upload/PreviewLetterPage'

import AddressPage from './views/letter/address/AddressPage'
import SenderLetterPage from './views/letter/address/SenderLetterPage'
import RecipientsPage from './views/letter/address/recipients/RecipientsPage'
import RecipientsManual from './views/letter/address/recipients/RecipientsManual'
import RecipientsUpload from './views/letter/address/recipients/RecipientsUpload'

import DeliveryPage from './views/letter/delivery/DeliveryPage'
import LetterDeliveryPage from './views/letter/delivery/LetterDeliveryPage'

import PayPage from './views/letter/approve-pay/PayPage'
import ApprovePreviewLetterPage from './views/letter/approve-pay/ApprovePreviewLetterPage'
import ApproveContactLetterPage from './views/letter/approve-pay/ApproveContactLetterPage'
import ApproveStatusPage from './views/letter/approve-pay/ApproveStatusPage'

import OrderList from './views/order/List'

import store from './store/index'
import * as routeGuardFns from './routeGuardFunctions'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: { name: 'landing' }
    },
    {
      path: '/',
      name: 'landing',
      component: LandingPage,
      children: [
        {
          path: 'address-book'
        }
      ]
    },
    {
      path: '/letter',
      component: LetterPage,
      children: [
        {
          path: '/',
          redirect: 'upload'
        },
        {
          path: 'upload',
          component: UploadPage,
          children: [
            {
              /* First child  for each step in the progress-bar should have '/' as route so it matches with the parent and renders on load */
              path: '/',
              component: LetterOptionsPage,
              name: 'upload'
            },
            {
              path: 'upload-selection',
              component: UploadSelectionPage,
              beforeEnter: routeGuardFns.uploadLetter,
              name: 'uploadSelection'
            },
            {
              path: 'upload-letter',
              component: UploadLetterPage,
              beforeEnter: routeGuardFns.uploadLetter,
              name: 'uploadLetter'
            },
            {
              path: 'preview-letter',
              component: PreviewLetterPage,
              beforeEnter: routeGuardFns.previewLetter,
              name: 'previewLetter'
            }
          ]
        },
        {
          path: 'address',
          component: AddressPage,
          children: [
            {
              path: '/',
              component: SenderLetterPage,
              name: 'address'
            },
            {
              path: 'recipients',
              component: RecipientsPage,
              name: 'recipients'
            },
            {
              path: 'recipients/manual',
              component: RecipientsManual,
              name: 'recipients-manual'
            },
            {
              path: 'recipients/upload',
              component: RecipientsUpload,
              name: 'recipients-upload'
            }
          ]
        },
        {
          path: 'delivery',
          component: DeliveryPage,
          children: [
            {
              path: '/',
              component: LetterDeliveryPage,
              // NOTE: uncomment this when conditions are ready
              // beforeEnter: routeGuardFns.deliveryLetter,
              name: 'delivery'
            }
          ]
        },
        {
          path: 'pay',
          component: PayPage,
          children: [
            {
              path: '/',
              component: ApprovePreviewLetterPage,
              beforeEnter: routeGuardFns.approveLetter,
              name: 'pay'
            },
            {
              path: 'approve-contact-letter',
              component: ApproveContactLetterPage,
              beforeEnter: routeGuardFns.approveSenderInfo,
              name: 'contactInformation'
            },
            {
              path: 'approve-status',
              component: ApproveStatusPage,
              name: 'approveStatus',
              beforeEnter: routeGuardFns.approveStatus,
              meta: { disableProgressBar: true }
            }
          ]
        }
      ]
    },
    {
      path: '/prisberaknare-for-utskick',
      name: 'prisberaknare',
      beforeEnter() {
        routeGuardFns.redirectToExternal(
          process.env.VUE_APP_PRICE_CALCULATIN_PAGE_URL
        )
      }
    },
    {
      path: '/utdelningsdag',
      name: 'sendout-arrival',
      beforeEnter() {
        routeGuardFns.redirectToExternal(
          process.env.VUE_APP_SEND_OUT_ARRIVAL_URL
        )
      }
    },
    {
      path: '/postcard',
      meta: { v1Redirect: true },
      beforeEnter() {
        routeGuardFns.redirectToV1('admail-postcard')
      }
    },
    {
      path: '/flyer',
      meta: { v1Redirect: true },
      beforeEnter() {
        routeGuardFns.redirectToV1('admail-flyers')
      }
    },
    {
      path: '/flyer-envelope',
      meta: { v1Redirect: true },
      beforeEnter() {
        routeGuardFns.redirectToV1('admail-letter')
      }
    },
    {
      path: '/odr',
      meta: { v1Redirect: true },
      beforeEnter() {
        routeGuardFns.redirectToV1('admail-odr')
      }
    },
    {
      path: '/order/list',
      name: 'myOrders',
      component: OrderList,
      beforeEnter: routeGuardFns.orderList
    },
    {
      path: '/learn-more',
      beforeEnter: routeGuardFns.redirectLearnMoreLink
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  store.dispatch('checkUserAccess')
  if (!to.meta.v1Redirect) {
    store.dispatch('setAccessToken')
  }

  next()
})

export default router
